'use client';

import { useEffect } from 'react';

import './globals.css';

import { Geist } from 'next/font/google';

import ErrorLayout from '@/components/global/ErrorLayout';

const geistSans = Geist({
  variable: '--font-geist-sans',
  subsets: ['latin']
});

type T_GlobalErrorProps = {
  error: Error;
  reset: () => void;
};

const GlobalError = ({ error, reset: _reset }: T_GlobalErrorProps) => {
  useEffect(() => {
    //! Optionally log the error to an error reporting service
    console.error('Global error -> ', error);
  }, [error]);

  return (
    <html className={geistSans.variable}>
      <body>
        <main className="bg-main-gradient">
          {/* Note: Global error handler doesn't have access to NextIntlProvider, 
               so we use hardcoded English strings as fallback */}
          <ErrorLayout
            type="internal"
            className="bg-[linear-gradient(179deg,hsla(0,74.7%,15.5%,1)_0%,hsla(0,0%,0%,1)_100%)]
                    md:bg-[linear-gradient(90deg,hsla(0,75%,15%,1)_0%,hsla(0,0%,0%,1)_100%)]"
            imagePath="/assets/images/errorLayouts/oops.png"
          />
        </main>
      </body>
    </html>
  );
};

export default GlobalError;
